if (!customElements.get('adev-announcement-bar')) {
    customElements.define('adev-announcement-bar', class adevAnnouncementBar extends HTMLElement {
        constructor() {
            super();
        }

        initSlider(){
            const carouselEl = this.querySelector('[data-adev-announcement-bar="carousel"]');

            this.slider = new Flickity(carouselEl, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false
            });

            const prevEl = this.querySelector('[data-adev-announcement-bar="prev"]');
            const nextEl = this.querySelector('[data-adev-announcement-bar="next"]');
            if (prevEl && nextEl) {

                const updateButtonState = () => {
                    // prevEl.disabled = this.slider.selectedIndex === 0;
                    // nextEl.disabled = this.slider.selectedIndex === this.slider.slides.length - 1;
                }

                prevEl.addEventListener('click', () => {
                    this.slider.previous();
                });

                nextEl.addEventListener('click', () => {
                    this.slider.next();
                });

                updateButtonState();

                this.slider.on('select', updateButtonState);
            }
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
        }

        shopifyCustomizerInit(){
            if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (e) => {
                    const block = e.detail;

                    const blockId = block.blockId;
                    const sectionId = block.sectionId;

                    const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                    
                    if (blockElement) {
                        const index = blockElement.getAttribute('data-index');
                        this.slider.select(index);
                    }
                });

                document.addEventListener('shopify:block:deselect', (e) => {
                    const block = e.detail;

                    const blockId = block.id;
                    const sectionId = block.sectionId;
                });
            }
        }

        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}